import { Partner } from '@bybeam/platform-types';
import Typography from '@platform-ui-common/components/Typography/index.js';
import Color, { BackgroundColors } from '@platform-ui-common/utilities/Color.js';
import { useUserHomeRoute } from '@platform-ui/utilities/Routes.js';
import { IKImage } from 'imagekitio-react';
import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import BeamLogo from '../BeamLogo/index.js';
import { HelpButton } from './NavButton.js';

interface ContainerProps {
  children: ReactNode;
}

export interface NavbarProps {
  partner?: Partner;
}

const NavbarContainer = ({ children }: ContainerProps): JSX.Element => {
  return (
    <header
      className={`${
        BackgroundColors[Color.White]
      } drop-shadow sticky top-0 z-10 lg:static lg:z-auto`}
    >
      {children}
    </header>
  );
};

const PoweredByBeam = (): JSX.Element => (
  <div className="flex flex-col ml-4 lg:ml-10">
    <Typography variant="fieldLabel">powered by</Typography>
    <BeamLogo />
  </div>
);

export default function Navbar({ partner }: NavbarProps): JSX.Element {
  const homeRoute = useUserHomeRoute();
  const desktopWidthClasses = 'lg:w-4/5 lg:max-w-[96rem] lg:mx-auto';

  return (
    <NavbarContainer>
      <div
        className={`
          flex justify-between items-center h-16 px-5 
          ${desktopWidthClasses} lg:px-0`}
      >
        <div className="h-full flex justify-start items-center h-inherit py-3 lg:py-4">
          <Link to={homeRoute} className="h-full flex items-center">
            {partner && (
              <IKImage
                src={partner.whitelabeling.logo}
                alt={`${partner.name} logo`}
                className="max-h-full max-w-[8rem] lg:max-w-[10rem]"
                urlEndpoint="https://ik.imagekit.io/bybeam/"
                transformation={[{ height: '32', dpr: `${window.devicePixelRatio}` }]}
              />
            )}
          </Link>
        </div>
        <HelpButton link="http://bybeam.zendesk.com/" />
      </div>
    </NavbarContainer>
  );
}
